export enum ActionType {
    SELF_ORDER_ERROR="SELF_ORDER_ERROR"
}

interface ISelfOrderError {
    type: ActionType.SELF_ORDER_ERROR,
    payload: string
}

export type Action = ISelfOrderError;